import { getUtmTagsFromUrl } from '@/utils/utm';
import { generateSession } from './useGenerateSession';
import { BACKEND_API_BASE_URL } from './constants';

let isRefreshing = false;
let failedRequestQueue: Array<() => void> = [];

function processQueue(error: any = null) {
  failedRequestQueue.forEach((cb) => cb());
  failedRequestQueue = [];
  if (error) console.error(error);
}

export default async function secureApi(
  input: RequestInfo,
  init: RequestInit & { _retry?: boolean } = {}
): Promise<Response> {
  const url = input.toString().startsWith('http') ? input : `${BACKEND_API_BASE_URL}${input}`;

  const options: RequestInit & { _retry?: boolean } = {
    ...init,
    credentials: 'include',
  };

  const response = await fetch(url, options);

  if (response.status !== 401) {
    return response;
  }

  if (!options._retry) {
    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedRequestQueue.push(async () => {
          try {
            const retryResponse = await secureApi(input, { ...options, _retry: true });
            resolve(retryResponse);
          } catch (e) {
            reject(e);
          }
        });
      });
    }

    isRefreshing = true;
    const utmTags = JSON.stringify(getUtmTagsFromUrl());

    try {
      await generateSession({ utmTags });
      isRefreshing = false;
      processQueue();
      return secureApi(input, { ...options, _retry: true });
    } catch (err) {
      isRefreshing = false;
      processQueue(err);
      console.error('Session generation failed:', err);
      throw err;
    }
  }

  throw new Error('Unauthorized and retry failed');
}
